module.exports = __webpack_public_path__ + "media/images/subcat-illust-64d2105a8f3b8f399b71ebb5ebca9111.png";